import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GamesService } from 'app/core/games.service';
import { BalanceService, CurrencyType } from '@app/core/balance.service';
import { Subscription } from 'rxjs/Subscription';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.template.html',
  styleUrls: ['./leaderboard.styles.scss'],
})
export class LeaderboardComponent implements OnInit, OnDestroy {
  @Input() rows: number = 6;

  currency: CurrencyType;

  logs: Array<any> = [];
  subs: Subscription = new Subscription();

  constructor(private service: GamesService, private balance: BalanceService) {}

  ngOnInit() {
    this.getLogs(this.rows, this.balance.getCurrency());
    this.balance
      .currencyObservable()
      .pipe(filter(e => e !== this.currency))
      .subscribe((currency: CurrencyType) => {
        this.getLogs(this.rows, currency);
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getLogs(rows: number, currency: CurrencyType) {
    this.service
      .getLeaderboard(rows, currency)
      .pipe(take(1))
      .subscribe(logs => {
        this.logs = logs;
        this.currency = currency;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/leaderboard-bets-wrapper/leaderboard/leaderboard.component.ts